import SurgeonSection from "@/components/site/SurgeonSection";
import InduceXTHero from "@/components/site/InduceXTHero";

export default function ForSurgeonsPage() {
    return (
        <div data-testid="for-surgeons-page">
            <SurgeonSection />
            <InduceXTHero />
        </div>
    );
}
